import { useContext } from 'react';

import { Context } from './ModalsProvider';

export default () => {
  return useContext(Context);
};
